import { render } from "./AddSongView.vue?vue&type=template&id=af6eaccc"
import script from "./AddSongView.vue?vue&type=script&lang=js"
export * from "./AddSongView.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./AddSongView.vue?vue&type=style&index=1&id=af6eaccc&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__